export default __webpack_public_path__ + "static/media/Meta.edb96470.jpg";